import React from 'react';
import { Container } from './styles';

interface ListItensFollowupsProps {
  listOrgaos: any;
}

const ListItensOrgaos = (props: ListItensFollowupsProps) => {
  const { listOrgaos } = props;

  return (
    <Container>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome do Órgão</th>
              <th scope="col">Estado</th>
              <th scope="col">Licitações</th>
              <th scope="col">Investimento</th>
            </tr>
          </thead>
          <tbody>
            {listOrgaos?.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center border-0 pb-0">
                  <div className="alert alert-secondary m-0" role="alert">
                    <p className="mb-0">Não foram encontrados resultados para este filtro.</p>
                  </div>
                </td>
              </tr>
            ) : (
              listOrgaos?.map((orgao: any) => (
                <tr key={orgao?.orgao}>
                  <td>{orgao?.orgao}</td>
                  <td>{orgao?.estado}</td>
                  <td>{orgao?.licitacoes}</td>
                  <td>
                    {orgao?.investimento.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default ListItensOrgaos;
